
import { defineComponent } from 'vue'

import TheButton from '@/common/components/UI/TheButton/index.vue'
import useImpersonate from '@/common/composable/useImpersonate'

import declOfNum from '@/common/helpers/declOfNum'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    setup() {
        const { impersonate_state, impersonateQuit } = useImpersonate(false)
        return { impersonate_state, impersonateQuit, declOfNum }
    },
})
